let urlToPreload,mouseoverTimer,lastTouchTimestamp;const prefetcher=document.createElement("link"),isSupported=prefetcher.relList&&prefetcher.relList.supports&&prefetcher.relList.supports("prefetch"),isDataSaverEnabled=navigator.connection&&navigator.connection.saveData,allowQueryString="instantAllowQueryString"in document.body.dataset,allowExternalLinks="instantAllowExternalLinks"in document.body.dataset;if(isSupported&&!isDataSaverEnabled){prefetcher.rel="prefetch",document.head.appendChild(prefetcher);const e={capture:!0,passive:!0};document.addEventListener("touchstart",touchstartListener,e),document.addEventListener("mouseover",mouseoverListener,e)}function touchstartListener(e){lastTouchTimestamp=performance.now();const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("touchcancel",touchendAndTouchcancelListener,{passive:!0}),t.addEventListener("touchend",touchendAndTouchcancelListener,{passive:!0}),urlToPreload=t.href,preload(t.href))}function touchendAndTouchcancelListener(){urlToPreload=void 0,stopPreloading()}function mouseoverListener(e){if(performance.now()-lastTouchTimestamp<1100)return;const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("mouseout",mouseoutListener,{passive:!0}),urlToPreload=t.href,mouseoverTimer=setTimeout(()=>{preload(t.href),mouseoverTimer=void 0},65))}function mouseoutListener(e){e.relatedTarget&&e.target.closest("a")==e.relatedTarget.closest("a")||(mouseoverTimer?(clearTimeout(mouseoverTimer),mouseoverTimer=void 0):(urlToPreload=void 0,stopPreloading()))}function isPreloadable(e){if(!e||!e.href)return;if(urlToPreload==e.href)return;const t=new URL(e.href);if("/cart" == t.pathname || t.pathname.startsWith("/cart/"))return;return!(!(allowExternalLinks||t.origin==location.origin||"instant"in e.dataset)||!["http:","https:"].includes(t.protocol)||"http:"==t.protocol&&"https:"==location.protocol||!(allowQueryString||!t.search||"instant"in e.dataset)||t.hash&&t.pathname+t.search==location.pathname+location.search||"noInstant"in e.dataset)||void 0}function preload(e){prefetcher.href=e}function stopPreloading(){prefetcher.removeAttribute("href")}

/* ColorPlay: decorador del boton Mesa de Regalos (Uiverse vinh_8995) — inyecta fold + estrellitas + sparkle, y TRADUCE los labels del app a espanol (Gift Reggie sirve ingles mientras la traduccion Default no este activa). Un MutationObserver re-decora cuando el app cambia el texto (pending/added/etc). CSS en custom.css (.gr-*). */
(function(){
  var ES={
    'Add to Registry':'Agregar a Mesa de Regalos',
    'Remove from Registry':'Quitar de Mesa de Regalos',
    'Added to Registry':'Agregado a tu Mesa',
    'Removed from Registry':'Quitado de tu Mesa',
    'Add to Wishlist':'Agregar a Apartados',
    'Error':'Error'
  };
  function esLabel(t){return ES[t]||t;}
  var SPARKLE='<svg class="gr-icon" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10,21.236,6.755,14.745.264,11.5,6.755,8.255,10,1.764l3.245,6.491L19.736,11.5l-6.491,3.245ZM18,21l1.5,3L21,21l3-1.5L21,18l-1.5-3L18,18l-3,1.5ZM19.333,4.667,20.5,7l1.167-2.333L24,3.5,21.667,2.333,20.5,0,19.333,2.333,17,3.5Z"></path></svg>';
  function decorate(){
    var btn=document.querySelector('.giftreggie-pdp-registry-cta');
    if(!btn)return false;
    if(btn.dataset.cpMagic==='1'&&btn.querySelector('.gr-inner'))return true;
    var label=esLabel(btn.textContent.trim());
    btn.textContent='';
    var fold=document.createElement('span');fold.className='gr-fold';
    var pts=document.createElement('span');pts.className='gr-points';
    for(var i=0;i<10;i++){var p=document.createElement('i');p.className='gr-point';pts.appendChild(p);}
    var inner=document.createElement('span');inner.className='gr-inner';
    inner.innerHTML=SPARKLE;
    inner.appendChild(document.createTextNode(label));
    btn.appendChild(fold);btn.appendChild(pts);btn.appendChild(inner);
    btn.dataset.cpMagic='1';
    if(!btn.dataset.cpObs){
      btn.dataset.cpObs='1';
      new MutationObserver(function(){
        if(!btn.querySelector('.gr-inner')){btn.dataset.cpMagic='';decorate();}
      }).observe(btn,{childList:true});
    }
    return true;
  }
  var tries=0;
  var t=setInterval(function(){if(decorate()||++tries>40)clearInterval(t);},250);
  if(document.readyState!=='loading'){decorate();}else{document.addEventListener('DOMContentLoaded',decorate);}
})();

/* ColorPlay: links de WhatsApp con mensaje pre-llenado + target _blank. En PDP el mensaje incluye producto + URL. Evita que el click bote la sesion de compra. */
(function(){
  function fixWA(){
    document.querySelectorAll('a[href*="wa.me"], a[href*="api.whatsapp.com"]').forEach(function(a){
      a.target='_blank'; a.rel='noopener';
      try{
        var u=new URL(a.href);
        if(!u.searchParams.get('text')){
          var msg='¡Hola! Estoy en su tienda en línea y me gustaría más información';
          if(location.pathname.indexOf('/products/')!==-1){
            var t=document.querySelector('h1');
            msg='¡Hola! Me interesa este producto: '+(t?t.textContent.trim():'')+' — '+location.origin+location.pathname;
          }
          u.searchParams.set('text',msg);
          a.href=u.toString();
        }
      }catch(e){}
    });
  }
  if(document.readyState!=='loading'){fixWA();}else{document.addEventListener('DOMContentLoaded',fixWA);}
  setTimeout(fixWA,2500);
})();

/* ColorPlay: barra de progreso hacia envio gratis (L 2,000) en el cart drawer y pagina de carrito. Lee /cart.js y se re-inyecta cuando el drawer se re-renderiza. */
(function(){
  var THRESHOLD=200000;
  var lastTotal=null;
  function money(c){return 'L '+Math.ceil(c/100).toLocaleString('es-HN');}
  function render(total){
    var host=document.querySelector('cart-drawer .drawer__footer')||document.querySelector('.cart__footer');
    if(!host)return;
    var bar=host.querySelector('.cp-freeship');
    var isNew=false;
    if(!bar){
      bar=document.createElement('div');bar.className='cp-freeship';
      bar.innerHTML='<div class="cp-freeship__msg"></div><div class="cp-freeship__track"><div class="cp-freeship__fill"></div></div>';
      host.insertBefore(bar,host.firstChild);
      isNew=true;
    }
    if(!isNew&&total===lastTotal)return;
    var pct=Math.min(100,Math.round(total/THRESHOLD*100));
    bar.querySelector('.cp-freeship__fill').style.width=pct+'%';
    var msg=bar.querySelector('.cp-freeship__msg');
    if(total>=THRESHOLD){msg.textContent='Tenés ENVÍO GRATIS en este pedido';bar.classList.add('cp-freeship--done');}
    else{msg.textContent='Te faltan '+money(THRESHOLD-total)+' para envío gratis';bar.classList.remove('cp-freeship--done');}
    lastTotal=total;
  }
  var pending=false;
  function refresh(){
    if(pending)return;pending=true;
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){pending=false;render(c.total_price);}).catch(function(){pending=false;});
  }
  var deb;
  function onMut(){clearTimeout(deb);deb=setTimeout(refresh,350);}
  function watch(){
    var d=document.querySelector('cart-drawer');
    if(d&&!d.dataset.cpFs){d.dataset.cpFs='1';new MutationObserver(onMut).observe(d,{childList:true,subtree:true});}
  }
  function boot(){refresh();watch();}
  if(document.readyState!=='loading'){boot();}else{document.addEventListener('DOMContentLoaded',boot);}
  setTimeout(boot,2500);
})();





/* ColorPlay cp-fab-yield: oculta el FAB de WhatsApp mientras los botones de compra (carrito, comprar ahora, mesa de regalos) estan visibles. */
(function(){
  if (!('IntersectionObserver' in window)) return;
  var targets = [];
  var add = function(sel){ var el = document.querySelector(sel); if (el) targets.push(el); };
  add('#cp-add-btn'); add('.cp-product__dynamic-checkout'); add('.giftreggie-pdp-registry-cta');
  if (!targets.length) return;
  var visible = new Set();
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ e.isIntersecting ? visible.add(e.target) : visible.delete(e.target); });
    document.documentElement.classList.toggle('cp-fab-hide', visible.size > 0);
  }, {threshold: 0.05});
  targets.forEach(function(t){ io.observe(t); });
})();
